module.exports = __webpack_public_path__ + "img/1395029852.fdfc18d6.jpg";